import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allAdminVisit,allAgentName} from '../../api'
  
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'adminindex',
  setup(__props) {

  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);

  const allAgentNameArr=ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const search = reactive({
    key:"",
    status:0,
    rangeTime:[],
    searchKey:""
  })
  
  const columns = ref([
    // { title: "id", key: "id", align: "left" },
         { title: "是否隐藏", key: "show", align: "center", customSlot: "show",width:60},  
      { title: "代理", key: "userName", align: "center",width:60 }, 
      { title: "推广方式/ip/状态/logo", key: "type", align: "left", customSlot: "type",width:100,ellipsisTooltip: true },  

     { title: "操作类型", key: "recordType", align: "center", customSlot: "recordType" ,width:60 },  
     { title: "入口/访问/参数", key: "referer", align: "left", customSlot: "entryAccessParameters",width:200,ellipsisTooltip: true},  
    { title: "浏览器信息", key: "browser", align: "left",ellipsisTooltip: true , customSlot: "browserInfo",width:400},
    { title: "平台", key: "platform", align: "center" ,width:60},  
    { title: "时间", key: "addTime", align: "center" ,width:60}, 
  ]);
  
  const getAllAdminUser = () => {
    loading.value = true; 
    var data = { "page": page.current, "limit": page.limit, "key": search.key,"state":search.status, "startTime":search.rangeTime[0],"endTime":search.rangeTime[1],"searchKey":search.searchKey};
    allAdminVisit(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdminUser();
  
  const change = (page: any) => {
    getAllAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllAdminUser();
  }
   
  const allAgentNameList=()=>{
   
    allAgentName().then((res: any) => {
    
      if (res != "" && res.code == 0) {
        allAgentNameArr.value = res.data;
      
      } else {
        allAgentNameArr.value=[];
      }
    })

  }
  allAgentNameList();
  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_date_picker = _resolveComponent("lay-date-picker")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_space = _resolveComponent("space")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form, {
                model: search,
                style: {"text-align":"start"},
                size: "sm"
              }, {
                default: _withCtx(() => [
                  (allAgentNameArr.value.length!=0)
                    ? (_openBlock(), _createBlock(_component_lay_form_item, {
                        key: 0,
                        label: "代理账号",
                        prop: "username",
                        mode: "inline"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select, {
                            modelValue: search.key,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                            "show-search": true,
                            multiple: false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAgentNameArr.value, (agent) => {
                                return (_openBlock(), _createBlock(_component_lay_select_option, {
                                  key: agent.userId,
                                  value: agent.userId,
                                  label: agent.userName
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_lay_form_item, {
                    label: "搜索",
                    prop: "searchKey",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        placeholder: "请输入ip/入口/访问/参数",
                        modelValue: search.searchKey,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.searchKey) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "状态",
                    prop: "status",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: search.status,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.status) = $event)),
                        "show-search": true,
                        multiple: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: 0,
                            label: "全部"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 7,
                            label: "正常"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 1,
                            label: "指纹重复"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 2,
                            label: "IP重复"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 3,
                            label: "请求头部重复"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 4,
                            label: "设备重复"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 5,
                            label: "老用户"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 6,
                            label: "来源异常"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "日期范围",
                    mode: "inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_date_picker, {
                        modelValue: search.rangeTime,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.rangeTime) = $event)),
                        range: "",
                        type: "datetime",
                        placeholder: ['开始日期','结束日期']
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_button, {
                        type: "primary",
                        size: "sm",
                        onClick: searchUser
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[4] || (_cache[4] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange,
                size: "sm"
              }, {
                type: _withCtx(({ row }) => [
                  _createVNode(_component_space, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" 推广方式： "),
                      (row.type==1)
                        ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 代理推广 ")
                            ]),
                            _: 1
                          }))
                        : (row.type==2)
                          ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 用户分享 ")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_space, { key: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 自来用户 ")
                              ]),
                              _: 1
                            }))
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", null, " IP：" + _toDisplayString(row.ip), 1),
                  _createElementVNode("div", null, [
                    _createVNode(_component_space, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" 状态： "),
                        (row.state==0)
                          ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 正常 ")
                              ]),
                              _: 1
                            }))
                          : (row.state==1)
                            ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 指纹重复 ")
                                ]),
                                _: 1
                              }))
                            : (row.state==2)
                              ? (_openBlock(), _createBlock(_component_space, { key: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" ip重复 ")
                                  ]),
                                  _: 1
                                }))
                              : (row.state==3)
                                ? (_openBlock(), _createBlock(_component_space, { key: 3 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 请求头部重复 ")
                                    ]),
                                    _: 1
                                  }))
                                : (row.state==4)
                                  ? (_openBlock(), _createBlock(_component_space, { key: 4 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" 设备重复 ")
                                      ]),
                                      _: 1
                                    }))
                                  : (row.state==5)
                                    ? (_openBlock(), _createBlock(_component_space, { key: 5 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 老用户 ")
                                        ]),
                                        _: 1
                                      }))
                                    : (row.state==6)
                                      ? (_openBlock(), _createBlock(_component_space, { key: 6 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" 来源异常 ")
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createVNode(_component_space, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" logo状态： "),
                      (row.logoType==0)
                        ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 无访问 ")
                            ]),
                            _: 1
                          }))
                        : (row.logoType==1)
                          ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 有访问 ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                entryAccessParameters: _withCtx(({ row }) => [
                  _createElementVNode("div", null, "入口：" + _toDisplayString(row.referrer), 1),
                  _createElementVNode("div", null, "访问：" + _toDisplayString(row.referer), 1),
                  _createElementVNode("div", null, "参数：" + _toDisplayString(row.urlParams), 1)
                ]),
                browserInfo: _withCtx(({ row }) => [
                  _createElementVNode("div", null, "浏览器指纹：" + _toDisplayString(row.visitorId), 1),
                  _createElementVNode("div", null, "浏览器：" + _toDisplayString(row.browser), 1),
                  _createElementVNode("div", null, "分辨率：" + _toDisplayString(row.screenResolution), 1),
                  _createElementVNode("div", null, "操作系统：" + _toDisplayString(row.platformTyep), 1),
                  _createElementVNode("div", null, "语言：：" + _toDisplayString(row.browserLanguage), 1),
                  _createElementVNode("div", null, "时区：" + _toDisplayString(row.timeZone), 1),
                  _createElementVNode("div", null, "CPU 核心数：" + _toDisplayString(row.cpuCores), 1),
                  _createElementVNode("div", null, "网关： " + _toDisplayString(row.networkInfo), 1),
                  _createElementVNode("div", null, "请求头： " + _toDisplayString(row.userAgent), 1)
                ]),
                recordType: _withCtx(({ row }) => [
                  (row.recordType==1)
                    ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 访问 ")
                        ]),
                        _: 1
                      }))
                    : (row.recordType==2)
                      ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 下载 ")
                          ]),
                          _: 1
                        }))
                      : (row.recordType==3)
                        ? (_openBlock(), _createBlock(_component_space, { key: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 安装 ")
                            ]),
                            _: 1
                          }))
                        : (row.recordType==4)
                          ? (_openBlock(), _createBlock(_component_space, { key: 3 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 注册 ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                ]),
                show: _withCtx(({ row }) => [
                  (row.show==0)
                    ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 显示 ")
                        ]),
                        _: 1
                      }))
                    : (row.show==1)
                      ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 隐藏 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})